import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6",
  viewBox: "0 0 42 28"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#3D942F",
  d: "M.783.745A2.6 2.6 0 0 1 2.606 0h36.79c.713 0 1.36.287 1.83.753L20.885 18.541z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#A6E61F",
  d: "M0 2.603v22.798a2.605 2.605 0 0 0 2.605 2.603h28.964L.782.744A2.59 2.59 0 0 0 0 2.605z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#59BC1C",
  d: "M42 25.401V2.603c0-.724-.294-1.38-.773-1.85L20.884 18.541l10.685 9.463h7.827A2.606 2.606 0 0 0 42 25.401"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }